// extracted by mini-css-extract-plugin
export var orderSummary = "_tk-0";
export var showMoreLessButton = "_tk-1";